<template>
  <span class="two-way-controls">
    <v-btn v-if="!backHidden" class="control-button back-button" text @click="onPreviousClicked">
      {{ backTitle }}
    </v-btn>
    <v-btn
      v-if="!forwardHidden"
      class="control-button forward-button"
      :class="{ disabled: !forwardActive }"
      :disabled="!forwardActive"
      :loading="forwardLoading"
      @click="onNextClicked"
    >
      {{ forwardTitle }}
    </v-btn>
  </span>
</template>

<script>
export default {
  name: 'TwoWayControls',
  props: {
    forwardActive: {
      type: Boolean,
      required: true,
    },
    backHidden: {
      type: Boolean,
      default: false,
    },
    forwardHidden: {
      type: Boolean,
      default: false,
    },
    forwardLoading: {
      type: Boolean,
      default: false,
    },
    backTitle: {
      type: String,
      required: true,
    },
    forwardTitle: {
      type: String,
      required: true,
    },
  },
  methods: {
    onPreviousClicked() {
      this.$emit('click:back');
    },
    onNextClicked() {
      this.$emit('click:forward');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.two-way-controls {
  display: flex;
  flex-wrap: nowrap;

  .v-btn.control-button {
    font-size: $font-size-sm;
    font-weight: 500;
    letter-spacing: rem(1.07);
    line-height: rem(16);

    &.v-btn--disabled.disabled {
      background-color: var(--bg-tertiary);
    }

    &.back-button {
      color: var(--link-primary);
      margin-right: $space-3;
    }

    &.forward-button {
      box-shadow: 0 rem(1) rem(1) 0 rgba(0, 0, 0, 0.14), 0 rem(2) rem(1) rem(-1) rgba(0, 0, 0, 0.12), 0 rem(1) rem(3) 0 rgba(0, 0, 0, 0.2);
      background-color: var(--btn-primary-bg);
      color: var(--btn-primary-text);
    }
  }
}
</style>
